<template>
  <section>
    <h1>{{ $t('auth.loginWithTwitterOrGoogle') }}</h1>
    <panel>
      <p>{{ $t('auth.pleaseLogin') }}</p>
      <p>
        {{ $t('auth.exchangeNote.prefix') }}
        <a href="/jewelterm.html" target="_blank">{{ $t('auth.exchangeNote.link') }}</a>
        {{ $t('auth.exchangeNote.suffix') }}
      </p>
      <div v-if="!isProduction">
        <p class="endpoint-note">
          {{ $t('auth.loginEndpoint') }}
          <span v-if="isEditing"><input type="text" ref="textField" @keypress="onTextFieldKeyPress" @blur="onTextFieldBlur" v-model="apiEndpointTextField"></span>
          <span v-else @click="onEndpointLabelClick">{{ apiEndpoint }}</span>
        </p>
      </div>
      <p><enlil-button :disabled="isEditing" @click="onTwitterLoginButtonClick">{{ $t('auth.doLoginWithTwitter') }}</enlil-button></p>
      <p><enlil-button :disabled="isEditing" @click="onGoogleLoginButtonClick">{{ $t('auth.doLoginWithGoogle') }}</enlil-button></p>
    </panel>
  </section>
</template>

<style lang="scss" scoped>
p {
  line-height: 1.5em;
}
.endpoint-note {
  font-size: 0.8em;
  font-weight: bold;
  color: #800;
}
</style>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import Consts from '../../lib/Consts'

import EnlilButton from '../../components/EnlilButton.vue'
import Panel from '../../components/Panel.vue'

export default {
  name: 'auth',
  components: {
    EnlilButton,
    Panel
  },
  computed: {
    ...mapState('session', ['apiEndpoint']),
    ...mapGetters('session', ['isLoggedIn', 'apiEndpointIsDefault']),
    isProduction () {
      return location.host === 'topia.tv'
    }
  },
  data: () => ({
    isEditing: false,
    apiEndpointTextField: ''
  }),
  methods: {
    ...mapActions('session', ['updateApiEndpoint']),
    ...mapActions(['displayAlert']),
    onTextFieldKeyPress (e) {
      if (e.keyCode === 13) {
        this.onTextFieldBlur()
      }
    },
    onTextFieldBlur () {
      if (this.apiEndpointTextField === '') {
        this.displayAlert({ message: 'エンドポイントが指定されていません' })
        return
      }

      if (!this.apiEndpointTextField.match(/^https?:\/\/[\w-]+(?:\.[\w-]+)*(?::\d+)?$/)) {
        this.displayAlert({ message: 'URLの形式が正しくありません。\nhttps://example.com あるいは http://localhost:3000 のようなフォーマットで入力します。\nスキームはhttpまたはhttpsのみです。\nドメインの後にスラッシュまたはパスを含めないでください。' })
        return
      }

      this.isEditing = false
      this.updateApiEndpoint({ apiEndpoint: this.apiEndpointTextField })
    },
    onEndpointLabelClick () {
      this.isEditing = true
      this.$nextTick(() => {
        this.$refs.textField.focus()
      })
    },
    onTwitterLoginButtonClick () {
      location.href = this.apiEndpoint + Consts.API_PATH_TWITTER_AUTH
    },
    onGoogleLoginButtonClick () {
      location.href = this.apiEndpoint + Consts.API_PATH_GOOGLE_AUTH
    }
  },
  mounted () {
    this.apiEndpointTextField = this.apiEndpoint
    if (this.isLoggedIn) {
      this.$router.replace('/')
    }
  }
}
</script>
